<template>
  <div>
    <v-subheader class="title-setting">Reposición</v-subheader>

    <v-form @submit.prevent ref="form" v-model="valid" class="py-4 px-4" v-on:submit.prevent="save">
      <v-row>
        <v-col cols="12">
          <v-checkbox
            v-model="item.reposicion_no_controlar_destino"
            label="No controlar ubicacion de destino en Tarea de Reposicion"
            hint="Indica si se puede reponer en otra ubicacion e igualmente marcar la tarea como completada"
            persistent-hint
            color="primary"
            :loading="loading_settings"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="item.reposicion_no_controlar_cantidad"
            label="No controlar cantidad minima en Tarea de Reposicion"
            hint="Indica si se puede reponer menor cantidad e igualmente marcar la tarea como completada"
            persistent-hint
            color="primary"
            :loading="loading_settings"
          />
        </v-col>

        <v-col cols="12" class="text-right mt-4">
          <v-btn :loading="loading" color="success" type="submit">Guardar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
    loading_settings: Boolean
  },
  mixins: [ValidMixin],
  watch: {
    mainItem: {
      handler(newVal) {
        this.item = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      item: JSON.parse(JSON.stringify(this.mainItem)), // copia profunda para evitar mutar la prop
    };
  },
  methods: {
    save(e) {
      if (this.valid) {
        this.$emit("createItem", e, this.item, 'reposicion');
      } else {
        console.log("Formulario no válido");
      }
    },
  },
};
</script>
